import type { SVGProps } from "react";

export default function LogOutIcon(props: SVGProps<SVGSVGElement>) {
  const { width = 17, height = 15, ...rest } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.6667 8.33329V6.66663H4.16667V4.16663L0 7.49996L4.16667 10.8333V8.33329H11.6667Z"
        fill="currentColor"
      />
      <path
        d="M15 0H7.49999C6.58083 0 5.83333 0.7475 5.83333 1.66667V5H7.49999V1.66667H15V13.3333H7.49999V10H5.83333V13.3333C5.83333 14.2525 6.58083 15 7.49999 15H15C15.9192 15 16.6667 14.2525 16.6667 13.3333V1.66667C16.6667 0.7475 15.9192 0 15 0Z"
        fill="currentColor"
      />
    </svg>
  );
}
